import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const usePartnerStore = defineStore("partner", () => {
  const httpStore = useHttpStore();

  const getPartnerCountries = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "partner/GetPartnerCountries", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorsInCountry = (country) => {
    var params = {
      searchBy: country,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "partner/GetDistributorsInCountry", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerCompanyBy = (searchBy) => {
    var params = {
      searchBy: searchBy,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "partner/GetPartnerCompanyBy", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorCompanyBy = (searchBy) => {
    var params = {
      searchBy: searchBy,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "partner/GetDistributorCompanyBy", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributor = (searchBy) => {
    var params = {
      searchBy: searchBy,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "partner/GetDistributor", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getEVoucherData = (searchBy) => {
    var params = {
      searchBy: searchBy,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "partner/GetEVoucherData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getCreditNoteData = (searchBy) => {
    var params = {
      searchBy: searchBy,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "partner/GetCreditNoteData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getPartnerCountries,
    getDistributorsInCountry,
    getPartnerCompanyBy,
    getDistributorCompanyBy,
    getDistributor,
    getEVoucherData,
    getCreditNoteData
  };
});